import { HttpClient, HttpErrorResponse, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { DataService } from './data.service';
import { ApiPVConfig, ConfigService } from './config.service';

@Injectable({
  providedIn: 'root'
})
export class PrivilegeService {
  private _apiconfig: ApiPVConfig;
  private apiUrl = '';
  private token = '';

  //private baseUrl = `${environment.apiurlPV}`;
  
  
  private WALAIcurrentUser =  []; 
  
  constructor(
    private http: HttpClient, 
    private data: DataService,
    private configService: ConfigService
  ) {
    this._apiconfig =  this.configService.apiPVConfig;
    this.apiUrl = this._apiconfig.url;
    this.token = this._apiconfig.token;
    this.data.currentTokenPV.subscribe(
      (tokenPV) => (this.token = tokenPV)
    )

    this.WALAIcurrentUser =  JSON.parse(localStorage.getItem('WALAIcurrentUser')); 

  }
  handleError(error: HttpErrorResponse): Observable<never> {
    return throwError(() => new Error(error.message));
  }

  
  // public get currentWalaiUserValue(): any {
  //   return this.WALAIcurrentUser.observers;
  // }


  //OP1API1
  public CheckPrivilegeUser(userid: string): Observable<any>{
    //const userId: string = this.WALAIcurrentUser[0].USERID;
    return this.http.get<any>(`${this.apiUrl}/api/CheckPrivilegeUser/${userid}`, {
      headers: new HttpHeaders()
      .set('Content-Type','application/json'),
      observe: 'response'
    }
    ).pipe(catchError(this.handleError));
  }
 
  //OP1API2
  public UserPrivilegeInfo(): Observable<any>{
    this.WALAIcurrentUser =  JSON.parse(localStorage.getItem('WALAIcurrentUser'));   
    const userId: string = this.WALAIcurrentUser[0].USERID;
    return this.http.get<any>(`${this.apiUrl}/api/UserPrivilegeInfo/${userId}`, {
      headers: new HttpHeaders()
      .set('Content-Type','application/json')
      .set('Authorization', `Bearer ${this.token}`),
      observe: 'response'
    }
    ).pipe(catchError(this.handleError));
  }


  //OP3API1
  public TransacPerPage(): Observable<any>{
    return this.http.get<any>(`${this.apiUrl}/api/TransacPerPage`, {
      headers: new HttpHeaders()
      .set('Content-Type','application/json')
      .set('Authorization', `Bearer ${this.token}`),
      observe: 'response'
    }
    ).pipe(catchError(this.handleError));
  }

  //OP3API2
  public LoadPVTransaction(section: number, perpage: number): Observable<any>{
    this.WALAIcurrentUser =  JSON.parse(localStorage.getItem('WALAIcurrentUser')); 
    const userId: string = this.WALAIcurrentUser[0].USERID;
    return this.http.get<any>(`${this.apiUrl}/api/LoadPVTransaction/${userId}/${section}/${perpage}`, {
      headers: new HttpHeaders()
      .set('Content-Type','application/json')
      .set('Authorization', `Bearer ${this.token}`),
      observe: 'response'
    }
    ).pipe(catchError(this.handleError));
  }


  //OP2API1
  public LoadUserGift(): Observable<any>{
    this.WALAIcurrentUser =  JSON.parse(localStorage.getItem('WALAIcurrentUser')); 
    const userId: string = this.WALAIcurrentUser[0].USERID;
    return this.http.get<any>(`${this.apiUrl}/api/LoadUserGift/${userId}`, {
      headers: new HttpHeaders()
      .set('Content-Type','application/json')
      .set('Authorization', `Bearer ${this.token}`),
      observe: 'response'
    }
    ).pipe(catchError(this.handleError));
  }

  //LB3API1
  public SeachUserByCode(membercode: string): Observable<any> {
    return this.http.get<any>(`${this.apiUrl}/api/SeachUserByCode/${membercode}`,{
      headers: new HttpHeaders() 
      .set('Content-Type','application/json')
      .set('Authorization', `Bearer ${this.token}`), 
      observe: 'response'
    }).pipe(catchError(this.handleError));
  }

   //LB5API1
   public CheckUserTransfer(): Observable<any> {
    this.WALAIcurrentUser =  JSON.parse(localStorage.getItem('WALAIcurrentUser')); 
    const userId: string = this.WALAIcurrentUser[0].USERID;
    return this.http.get<any>(`${this.apiUrl}/api/CheckUserTransfer/${userId}`,{
      headers: new HttpHeaders() 
      .set('Content-Type','application/json')
      .set('Authorization', `Bearer ${this.token}`), 
      observe: 'response'
    }).pipe(catchError(this.handleError));
  }


  //LB4API1
  public SearchPVMember(keyword: any): Observable<any> {
    return this.http.post<any>(`${this.apiUrl}/api/SearchPVMember`, keyword,
    {
      headers: new HttpHeaders() 
      .set('Content-Type','application/json')
      .set('Authorization', `Bearer ${this.token}`), 
      observe: 'response'
    }).pipe(catchError(this.handleError));
  } 

  //LB4API2
  public ViewUserPrivilegeInfo(userid: number): Observable<any> {
    return this.http.get<any>(`${this.apiUrl}/api/ViewUserPrivilegeInfo/${userid}`,
    {
      headers: new HttpHeaders() 
      .set('Content-Type','application/json')
      .set('Authorization', `Bearer ${this.token}`), 
      observe: 'response'
    }).pipe(catchError(this.handleError));
  }
  
  //LB5API2
  public TransferPoint(receiveId  : string, point : string): Observable<any> {
    this.WALAIcurrentUser =  JSON.parse(localStorage.getItem('WALAIcurrentUser')); 
    const ownerId: string = this.WALAIcurrentUser[0].USERID;
    let body: any = {}
    return this.http.post<any>(`${this.apiUrl}/api/TransferPoint/${ownerId}/${receiveId}/${point}`,body,
    {
      headers: new HttpHeaders() 
      .set('Content-Type','application/json')
      .set('Authorization', `Bearer ${this.token}`), 
      observe: 'response'
    }).pipe(catchError(this.handleError));
  }

}
